import { useEffect, useRef } from 'react';

// Generates a simple QR code using a public CDN API — no npm dependency
export default function QRCodePreview({ value, size = 120 }) {
  if (!value) return null;

  const encoded = encodeURIComponent(value);
  const src = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encoded}&bgcolor=ffffff&color=1e1e2e&margin=2`;

  return (
    <div className="flex flex-col items-center gap-2">
      <img
        src={src}
        alt="QR code"
        width={size}
        height={size}
        className="rounded-xl border border-border shadow-soft"
      />
      <p className="text-[10px] text-muted-foreground font-mono truncate max-w-[120px]">{value}</p>
    </div>
  );
}
